/**
 * Loan App Demo — Configuration
 * 
 * Centralized configuration for the demo flow.
 * API Key is pulled from env vars so it stays out of source code.
 * The route itself is behind AuthProvider, so this page can only
 * be reached after a valid OMS login session exists.
 */

const DEMO_CONFIG = {
  // Authentication — sent as X-API-Key header
  API_KEY: process.env.REACT_APP_DEMO_API_KEY || '',

  // DoqSolv — template to use for document generation
  TEMPLATE_ID: process.env.REACT_APP_DEMO_TEMPLATE_ID || '',

  // DocuStamp — bulk order to consume stamp papers from
  BULK_ORDER_ID: process.env.REACT_APP_DEMO_BULK_ORDER_ID || '',

  // Backend base URL (reuses the existing env var)
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000',
};

export default DEMO_CONFIG;
